const Routings = {
    HOME: "/",
    CURRICULUM: "/curriculum",
    PROGRAM_CALENDAR: "/program/calander",
    PROGRAM_EVENT: "/program/event",
    ABOUT_US: "/about",
    CONTACT_US: "/contact",
    LOGIN: "/login",
    REGISTER: "/register",
    VERIFY: "/auth/verify-email",
    VOLUNTEERS: "/volunteers",
    DASHBOARD: "/dashboard",
    HOMECONFIG:"/dashboard/home-config",
    ABOUTUSCONFIG:"/dashboard/about-config",
    CURRICULUMCONFIG:"/dashboard/curriculum-config",
    ACCREDITED:"/accredited",
    AWARDPART:"/awardpart",
    BILITERACY: "/biliteracy",
    VOLUNTEERSADD: "/volunteersadd",
    SUCCESS: "/success",
    STUDENT_REGISTRATION: "/student-registration",
    REGISTRATION_SUCCESS: "/registration-success",
    // Admin routes
    ADMIN_REGISTRATIONS: "registrations",
    ADMIN_ADMISSIONS: "admissions",
    ADMIN_CLASSROOM_MGMT: "classroom-management",
    ADMIN_MASTER: "master",
    ADMIN_VOLUNTEERS: "volunteers",
    ADMIN_ATTENDANCE: "attendance",
    ADMIN_PAYMENT: "payment",
    ADMIN_COMPLAINTS: "complaints",
    ADMIN_INVENTORY: "inventory",
    ADMIN_ROLE_CONFIG: "role-config",
    ADMIN_REPOSITORY: "repository",
    ADMIN_PROJECT_GUIDELINES: "project-guidelines",
    ADMIN_WITHDRAWAL: "admin-withdrawal",
    ADMIN_FORM_ACCESS: "form-access-config",
    ADMIN_PASSWORD_RESET: "password-reset",
    ADMIN_WEBSITE_CONFIG: "website-config",
    ADMIN_SOCIAL_MEDIA: "social-media",
    ADMIN_VP_LEAVE: "vp-leave-portal",
    // New Admin config routes
    ADMIN_BILITERACY: "admin-biliteracy",
    ADMIN_CALENDAR_CONFIG: "calendar-config",
    ADMIN_EVENT_CONFIG: "event-config",
    ADMIN_CONTACT_CONFIG: "contact-us-config",
    ADMIN_SEAL_CONFIG: "seal-biliteracy-config",
    // New Student route
    STUDENT_PROFILE: "student-profile",
    // Student routes
    PICUPANDDROP:"pickup-drop",
    COMPLAINT:"complaint-management",
    WITHDRAW:"withdrawal-enquiries",
    LEAVEREQUEST:"leave-management",
    CLASSROOM:"google-classroom",
    STUDENT_ACADEMIC_DOCS: "academic-documents",
    STUDENT_TEXTBOOKS: "textbooks",
    STUDENT_CLASSROOM_RESOURCES: "classroom-resources",
    STUDENT_PROGRESS_REPORT: "progress-report",
    STUDENT_PROJECT_GUIDELINES: "student-project-guidelines",
    STUDENT_SEAL_BILITERACY: "seal-of-biliteracy",
    StudentDashboard:"/dashboard",
    // Teacher Routes
    TEACHER_STUDENT_LIST: "teacher-student-list",
    TEACHER_ATTENDANCE: "teacher-attendance",
    TEACHER_PROGRESS_REPORT: "teacher-progress-report",
    TEACHER_BILITERACY: "teacher-biliteracy",
    TEACHER_QUESTION_PAPER: "teacher-question-paper",
    TEACHER_CLASSROOM: "teacher-classroom",
    TEACHER_PICKUP_DROP: "teacher-pickup-drop",
    TEACHER_DOCUMENTS: "teacher-documents",
    TEACHER_COMPLAINTS: "teacher-complaints",
    TEACHER_LEAVE: "teacher-leave",
    TEACHER_REIMBURSEMENT: "teacher-reimbursement",
    TEACHER_PROJECT_GUIDELINES: "teacher-project-guidelines",
    TEACHER_PROFILE: "teacher-profile",
    TEACHER_SUBMISSIONS: "teacher-submissions",
    // Parent routes
    PARENT_STUDENT_PROFILE: "parent-student-profile",
    PARENT_PROGRESS_REPORT: "parent-progress-report",
    PARENT_ATTENDANCE: "parent-attendance",
    PARENT_COMPLAINT: "parent-complaint",
    PARENT_WITHDRAWAL: "parent-withdrawal",
    // Staff routes
    STAFF_CHECKINOUT: "staff-checkinout",
    STAFF_LEAVE_CALENDAR: "staff-leave-calendar",
    STAFF_LEAVE: "staff-leave",
    STAFF_MANDATE_LEAVE: "staff-mandate-leave",
    STAFF_COMPLAINT: "staff-complaint",
    STAFF_REIMBURSEMENT: "staff-reimbursement",
    STAFF_PROFILE: "staff-profile",
    STAFF_INVENTORY: "staff-inventory",
    // Principal routes
    PRINCIPAL_REGISTRATIONS: "principal-registrations",
    PRINCIPAL_WITHDRAWAL: "principal-withdrawal",
    PRINCIPAL_LEAVE: "principal-leave",
    // New admin pages (gaps #5-#8, #10)
    ADMIN_STAFF_ATTENDANCE: "staff-attendance",
    ADMIN_QUESTION_PAPER: "admin-question-paper",
    ADMIN_TEXTBOOKS: "admin-textbooks",
    ADMIN_GOOGLE_CLASSROOM: "admin-google-classroom",
    HANDBOOKS: "/handbooks",
    // Flipbook
    FLIPBOOK: "/flipbook/:documentId",
    FLIPBOOK_BASE: "/flipbook",
    ADMIN_FLIPBOOK: "admin-flipbook",
}

export default Routings
